import { Pipe, PipeTransform } from '@angular/core';
import isEmpty from 'lodash/isEmpty';

@Pipe({
	name: 'formatTelLink',
	standalone: true
})
export class FormatTelLinkPipe implements PipeTransform {
	transform = (inputPhone: string | null | undefined): string => {
		// remove any character that is not a digit or letter 'x' (for an extension)
		const strippedInputPhone = inputPhone?.replace(/[^\dx]/g, '') ?? '';

		// get phone and extension
		const regexMatch = /(\d+)(x\d*)?/.exec(strippedInputPhone);
		const extension = regexMatch?.[2]?.replace('x', '');

		const phone = regexMatch?.[1] ?? '';
		const extensionStr = !isEmpty(extension) ? `;${extension}` : '';

		return `${phone}${extensionStr}`;
	};
}
